export const REGISTER_MEMBER = "REGISTER_MEMBER";
export const LOGIN_MEMBER = "LOGIN_MEMBER";
export const LOGOUT_MEMBER = "LOGOUT_MEMBER";
export const GET_ONE_USER = "GET_ONE_USER";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SUCCESS = "SUCCESS";
export const LOAD = "LOAD";
export const FAILD = "FAILD";
export const CURRENT_USER = "CURRENT_USER";
